import activate_default_state from "./default_state";

export const RESET_STATE = (state) => {
    Object.assign(state, activate_default_state())
}

export const SET_MODAL = (state, value) => {
    state.show_modal = value
}

export const SET_AUDIENCE_ID = (state, audience_id) => {
    state.audience_id = audience_id
}

export const SET_DESCRIPTION = (state, description) => {
    state.description = description
}

export const SET_STEP = (state, step) => {
    state.step = step
}

export const SET_STEP_STATUS = (state, value) => {
    state.step_status = value
}

export const SET_NOTIFICATION_PREFERENCE = (state, preference) => {
    state.notification = preference
}

export const SET_ACTIVATION = (state, activation) => {
    state.activation = activation
}

export const SET_AUDIENCE = (state, audience) => {
    state.audience = audience
}

export const SET_ACTIVATION_ANALYSES = (state, analyses) => {
    state.activation_analyses = analyses
}

export const SET_RANGE_MIN_AND_MAX = (state, {results, type}) => {
    const min = parseInt(results[0].index)
    const max = parseInt(results[results.length - 1].index)

    if (type === 'frequency') {
        state.limits.freq.min = min
        state.limits.freq.max = max
        state.limits.freq.range = [min, max]

    } else if (type === 'distance') {
        state.limits.distance.min = min
        state.limits.distance.max = max
        state.limits.distance.range = max
        state.limits.total = results[results.length - 1]['counts']

    }
}

export const SET_DISTANCE_LIMIT = (state, limit) => {
    state.limits.distance.range = limit
}

export const SET_DISTANCE_LIMIT_STATUS = (state, status) => {
    state.limits.distance.status = status
}

export const SET_FREQUENCY_LIMIT_STATUS = (state, status) => {
    state.limits.freq.status = status
}

export const SET_FREQUENCY_LIMIT_RANGE_BY_INDEX = (state, {index, value}) => {
    state.limits.freq.range[index] = value
}

export const SET_FREQUENCY_LIMIT_RANGE = (state, value) => {
    state.limits.freq.range = value
}

export const CALCULATE_TOTAL_VISITS = (state) => {
    let total = 0

    state.activation.freqResults.forEach((item) => {
        if (item.index >= state.limits.freq.range[0] && item.index <= state.limits.freq.range[1]) {
            total = total + item.counts
        }
    })

    state.limits.total = total
}

export const CALCULATE_TOTAL_VISITS_BY_DISTANCE = (state) => {
    let total = 0

    state.activation.distanceResults.forEach((item) => {
        if (parseInt(item.index) === parseInt(state.limits.distance.range)) {
            total = item.counts
        }
    })

    state.limits.total = total
}

export const SET_ACTIVATION_ENDPOINTS = (state, partners) => {
    state.partners = partners
}

export const SET_ACTIVATION_PARTNER = (state, partner) => {
    state.partner = partner
}

export const SET_PRICING_MODELS = (state, models) => {
    state.pricing_models = models
}

export const SET_PRICING_MODELS_DATA = (state, models) => {
    state.pricing_models_data = models
}

export const SET_PRICING_MODEL = (state, model) => {
    state.pricing_model = model
}

export const SET_PRICE = (state, price) => {
    state.price = price
}

export const SET_AUDIENCE_COMPRESSION_TYPE = (state, type) => {
    state.data_delivery.audience.compression = type
}

export const SET_AUDIENCE_JSON_SERVICE_ACCOUNT = (state, service_account) => {
    state.data_delivery.audience.service_account = service_account
}

export const SET_AUDIENCE_SERVICE_ACCOUNT_FILE = (state, service_account_file) => {
    state.data_delivery.audience.service_account_file = service_account_file
}

export const SET_AUDIENCE_INPUTS = (state, inputs) => {
    state.data_delivery.audience.inputs = inputs
}

export const SET_DATASTREAMS_OPTIONS = (state, datastreams) => {
    state.datastreams.all = datastreams
}

export const SET_DATASTREAMS_INPUTS = (state, inputs) => {
    state.data_delivery.datastreams = inputs
}

export const SET_DATASTREAMS_LOADING_COMPLETED = (state, status) => {
    state.datastreams_loading_completed = status
}

export const SET_DATASTREAMS_INPUTS_BY_INDEX = (state, {data_stream, input, value}) => {
    state.data_delivery.datastreams[data_stream].inputs[input] = value
}

export const SET_SINGLE_DATASTREAM_CREDENTIALS_BY_INDEX = (state, {data_stream, value}) => {
    state.data_delivery.datastreams[data_stream] = value
}

export const SET_DATASTREAMS_STATUS_BY_INDEX = (state, {data_stream, value}) => {
    state.data_delivery.datastreams[data_stream].status = value
}

export const SET_DATASTREAMS_VISUALIZING_STATUS_BY_INDEX = (state, {data_stream, value}) => {
    state.data_delivery.datastreams[data_stream].visualizing_status = value
}

export const SET_DATASTREAMS_COMPRESSION_TYPE_BY_INDEX = (state, {data_stream, value}) => {
    state.data_delivery.datastreams[data_stream].compression = value
}

export const SET_DATASTREAM_JSON_SERVICE_ACCOUNT = (state, {data_stream, service_account}) => {
    state.data_delivery.datastreams[data_stream].service_account = service_account
}

export const SET_DATASTREAM_SERVICE_ACCOUNT_FILE = (state, {data_stream, service_account}) => {
    state.data_delivery.datastreams[data_stream].service_account_file = service_account
}